export default __webpack_public_path__ + "static/media/barometer-audit-text.84285e03.svg";